import {
    actionTypes as betActionTypes,
    betObstructions,
} from './bet.actions';
import { actionTypes as bookmakersInfoActionTypes } from '../bookmakersInfo/bookmakersInfo.actions';
import { actionTypes as bookmakersListActionTypes } from '../bookmakersList/bookmakersList.actions';
import updateBetToViewStorage from '../utils/betToViewQualification';

const initialState = {
    isPlacingBet: false,
    placedBetDetails: {
        containsPending: false,
        freeBet: null,
        bets: [],
    },
    obstruction: betObstructions.NONE,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case betActionTypes.PLACE_BET_REQUEST:
            return {
                ...state,
                isPlacingBet: action.isPlacingBet,
            };
        case betActionTypes.PLACE_BET_SUCCESS:
            updateBetToViewStorage(action.placedBetDetails.bets);
            return {
                ...state,
                isPlacingBet: false,
                placedBetDetails: action.placedBetDetails,
            };
        case betActionTypes.CLEAR_PLACED_BET_DETAILS:
        case bookmakersInfoActionTypes.DELETE_BET:
        case bookmakersListActionTypes.SET_LOGGEDOUT:
            return {
                ...state,
                isPlacingBet: false,
                placedBetDetails: initialState.placedBetDetails,
            };
        case betActionTypes.SET_BET_OBSTRUCTION:
            return {
                ...state,
                obstruction: action.obstruction,
            }
        case betActionTypes.CLEAR_BET_OBSTRUCTION:
            return {
                ...state,
                obstruction: betObstructions.NONE,
            }
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// /src/js/common/bet/bet.reducer.js